<app-fleet-page-header
  (clearSearch)="model.setSearch('')"
  (export)="model.exportReport($event)"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event, true)"
  [columns]="state.columns$ | async"
  [counter]="(state.items$ | async)?.length ?? 0"
  [defaultSortOrder]="state.defaultSortOrder$ | async"
  [search]="state.search$ | async"
  [showCounter]="true"
  [showExport]="true"
  [showMobileMenuButton]="false"
  [sortOrder]="state.gridSortOrder$ | async"
  [templates]="{ countIcon }"
  titleText="ti-admin.billing.title"
></app-fleet-page-header>

<ng-template #countIcon>
  <app-icon-fleets-count [height]="22" [width]="22"></app-icon-fleets-count>
</ng-template>

<div [ngClass]="{ 'flex-grow-1': (state.items$ | async)?.length === 0 }" class="table-wrapper">
  <app-data-grid
    (loadMoreClicked)="onLoadMoreClicked()"
    (sortUpdated)="onSortUpdated($event)"
    [columns]="(state.columns$ | async) ?? []"
    [data]="(state.items$ | async) ?? []"
    [isLoading]="(state.isPending$ | async) ?? false"
    [isLoadingMore]="(state.isLoadingNextPage$ | async) ?? false"
    [noDataDescription]="
      (model.isSearchOrFilterApplied ? 'search.no-data-description' : '') | translate
    "
    [noDataIconTemplate]="
      model.isSearchOrFilterApplied ? gridEmptySearchIconTmpl : gridEmptyStateIconTmpl
    "
    [noDataTitle]="
      (model.isSearchOrFilterApplied
        ? 'search.no-data-title'
        : 'ti-admin.accounts.grid.no-data-title'
      ) | translate
    "
    [paginationEnabled]="(state.canLoadNextPage$ | async) ?? false"
    [sortOrder]="(state.gridSortOrder$ | async) || undefined"
    [templates]="{ name, billingMode, billingUsage, controls }"
    [timezone]="'UTC'"
  ></app-data-grid>
</div>

<ng-template #gridEmptySearchIconTmpl>
  <app-icon-no-search></app-icon-no-search>
</ng-template>

<ng-template #gridEmptyStateIconTmpl>
  <app-icon-file-search></app-icon-file-search>
</ng-template>

<ng-template #name let-row="row">
  <div (click)="onNameClicked(row.id)" class="account-name flex text-14 cursor-pointer">
    <section class="account-info-container flex flex--col">
      <div class="account-name">
        {{ row.name ?? row.legalName }}
        @if (!row.isActive) {
          <p-tag [rounded]="true" class="alert fw-600 p-2-6">
            {{ 'ti-admin.accounts.grid.suspended' | translate }}
          </p-tag>
        }
      </div>

      <span class="account-email">{{ row.email }}</span>
    </section>
  </div>
</ng-template>

<ng-template #billingMode let-row="row">
  <span class="color-gray-900 text-14">
    {{ 'ti-admin.accounts.grid.billing-' + row.billingMode | translate }}
  </span>
</ng-template>

<ng-template #billingUsage let-row="row">
  @if (row.billingUsage) {
    <span (click)="onLastBillClicked(row.id)" class="color-gray-900 text-14 cursor-pointer">
      ${{ row.billingUsage.grandTotal | number: '.2-2' }}
    </span>
  } @else {
    <span class="color-gray-900 text-14"> --- </span>
  }
</ng-template>

<ng-template #controls let-isMobile="isMobile" let-row="row">
  @if (row.isActive) {
    <p-button
      (click)="suspend(row)"
      [appCheckAccess]="[Resource.TSP, Action.Suspend]"
      [disabled]="processingAccount() === row.id"
      [icon]="isMobile ? 'pi' : ''"
      [severity]="'secondary'"
      class="h--40 p--16 text-14 fw-600 red"
    >
      <i class="pi pi-pause"> </i>
      @if (!isMobile) {
        {{ 'tsp-admin.fleets.page.suspend-btn' | translate }}
      }
    </p-button>
  } @else {
    <p-button
      (click)="activate(row)"
      [appCheckAccess]="[Resource.TSP, Action.Suspend]"
      [disabled]="processingAccount() === row.id"
      [icon]="isMobile ? 'pi' : ''"
      class="h--40 p--16 text-14 fw-600"
    >
      <app-icon-play-solid-reverse
        [color]="'var(--color-primary-500)'"
        [height]="20"
        [width]="20"
        class="icon"
      ></app-icon-play-solid-reverse>
      @if (!isMobile) {
        {{ 'tsp-admin.fleets.page.activate-btn' | translate }}
      }
    </p-button>
  }
</ng-template>

@if (model.showEditForm$ | async) {
  <app-ti-edit-account-dialog
    (cancelled)="model.showEditForm$.next(false)"
    (updated)="model.editAccount($event)"
    [account]="state.selectedItem$ | async"
    [errorMessage]="(state.errorMessage$ | async) || ''"
    [opened]="true"
    [processing]="!!(model.editingAccount$ | async)"
  ></app-ti-edit-account-dialog>
}
